// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Organization and Role Selection Page Styles */
.org-role-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #5b9bd5 0%, #70a8d6 100%);
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Source Sans Pro',
    sans-serif;
}

.org-role-card {
  background: white;
  padding: 50px 40px;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  width: 100%;
  max-width: 420px;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.org-role-title {
  text-align: center;
  color: #333;
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 8px;
  letter-spacing: -0.5px;
}

.org-role-subtitle {
  text-align: center;
  color: #666;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 30px;
}

.org-role-label {
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  font-size: 14px;
}

.org-role-select {
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  color: #333;
  background-color: #fff;
  transition: all 0.3s ease;
}

.org-role-select:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  outline: none;
}

.org-role-select:disabled {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}

.org-role-submit {
  background-color: #1a2d4a;
  border: none;
  padding: 12px 24px;
  font-weight: 600;
  font-size: 16px;
  border-radius: 25px;
  transition: all 0.3s ease;
  margin-top: 10px;
  height: 50px;
}

.org-role-submit:hover:not(:disabled) {
  transform: translateY(-2px);
  background-color: #0f1a2e;
  box-shadow: 0 5px 20px rgba(26, 45, 74, 0.3);
}

.org-role-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.alert {
  border-radius: 10px;
  border: none;
  margin-bottom: 20px;
  font-size: 14px;
}

@media (max-width: 600px) {
  .org-role-card {
    padding: 30px 20px;
  }

  .org-role-title {
    font-size: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/org-role-select.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb;;cAEY;AACd;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Organization and Role Selection Page Styles */\n.org-role-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #5b9bd5 0%, #70a8d6 100%);\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Source Sans Pro',\n    sans-serif;\n}\n\n.org-role-card {\n  background: white;\n  padding: 50px 40px;\n  border-radius: 20px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n  width: 100%;\n  max-width: 420px;\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.org-role-title {\n  text-align: center;\n  color: #333;\n  font-size: 32px;\n  font-weight: 700;\n  margin-bottom: 8px;\n  letter-spacing: -0.5px;\n}\n\n.org-role-subtitle {\n  text-align: center;\n  color: #666;\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 30px;\n}\n\n.org-role-label {\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 8px;\n  font-size: 14px;\n}\n\n.org-role-select {\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 10px 12px;\n  font-size: 14px;\n  color: #333;\n  background-color: #fff;\n  transition: all 0.3s ease;\n}\n\n.org-role-select:focus {\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n  outline: none;\n}\n\n.org-role-select:disabled {\n  background-color: #f5f5f5;\n  color: #999;\n  cursor: not-allowed;\n}\n\n.org-role-submit {\n  background-color: #1a2d4a;\n  border: none;\n  padding: 12px 24px;\n  font-weight: 600;\n  font-size: 16px;\n  border-radius: 25px;\n  transition: all 0.3s ease;\n  margin-top: 10px;\n  height: 50px;\n}\n\n.org-role-submit:hover:not(:disabled) {\n  transform: translateY(-2px);\n  background-color: #0f1a2e;\n  box-shadow: 0 5px 20px rgba(26, 45, 74, 0.3);\n}\n\n.org-role-submit:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.alert {\n  border-radius: 10px;\n  border: none;\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n\n@media (max-width: 600px) {\n  .org-role-card {\n    padding: 30px 20px;\n  }\n\n  .org-role-title {\n    font-size: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
